import React, { useState, useMemo } from 'react'
import { Divider, Skeleton } from 'antd'
import { useNavigate } from 'react-router-dom'
import InfiniteScroll from 'react-infinite-scroll-component';
import { useAdvertsList } from '../../hooks/useAdvertsList';
import { useTranslation } from 'react-i18next';
import { debounce } from '../../../services/Debounce.service';
import { ListPageHeader } from '../../components/ListPageHeader';
import AdvertList from '../../components/AdvertList/AdvertList.component'
import './AdvertsListPage.styles.css';

const AdvertsListPage = () => {
  const modern = useAdvertsList();
  const advertsData = modern.adverts.items;
  const hasMore = modern.adverts.hasNextPage();
  const loading = modern.loading;
  const initialLoading = modern.initialLoading;
  const removeAdvert = modern.removeAdvert;
  const fetchNextPageAdverts = modern.fetchNextPageAdverts;
  const search = modern.search;
  const navigate = useNavigate()
  const { t } = useTranslation()
  const [searchInputValue, setSearchInputValue] = useState<string>('');

  const handleAdvertCreateClick = () => {
    navigate('/adverts/create')
  }

  const debouncedSearch = useMemo(
    () => debounce((value: string) => {
      search(value);
    }, 300),
    [search]
  );

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchInputValue(value);
    debouncedSearch(value);
  }

  const fetchMoreData = () => {
    if (loading) return;
  fetchNextPageAdverts()
  }

  return (
    <div className="adverts-list-container">
      <ListPageHeader
        title={t('adverts', {ns: 'standard'})}
        subtitle={t('adverts-management', {ns: 'standard'})}
        searchPlaceholder={t('search-adverts', {ns: 'standard'})}
        searchValue={searchInputValue}
        onSearchChange={handleSearchChange}
        createButtonText={t('create-advert', {ns: 'standard'})}
        onCreateClick={handleAdvertCreateClick}
        loading={loading}
      />
      <div className="advert-list-content">
        <InfiniteScroll
          dataLength={advertsData.length}
          next={fetchMoreData}
          hasMore={hasMore}
          loader={<Skeleton active />}
          endMessage={loading || <Divider plain>{t('there-is-nothing-more', {ns: 'standard'})}</Divider>}
        >
          <AdvertList adverts={advertsData as any} isLoading={initialLoading} onDelete={removeAdvert} />
        </InfiniteScroll>
      </div>
    </div>
  )
}

export default AdvertsListPage
